// helper component for filter bar and suggest page allowing users to increment and decrement the number of repeated units, or reset to default

import React from 'react';

export default function Counter({ label, repeatedUnits, setRepeatedUnits, defaultMsg = 'Any', max }) {

    // increment counter, not above max
    const handleIncrement = (e) => {
        e.preventDefault();
        if (repeatedUnits === '') {
            setRepeatedUnits(1);
        } else if (repeatedUnits < max) {
            setRepeatedUnits(parseInt(repeatedUnits) + 1);
        }
    };

    // decrement counter, not below 1
    const handleDecrement = (e) => {
        e.preventDefault();
        setRepeatedUnits(repeatedUnits > 1 ? parseInt(repeatedUnits) - 1 : 1);
    };

    // reset counter to default
    const handleDefault = (e) => {
        e.preventDefault();
        setRepeatedUnits('');
    };

    return (
        <div className="field">
            <label>{label}</label>
            <div className="ui action input">
                <button className="ui button" onClick={handleDecrement}>-</button>
                <input
                    type="text"
                    readOnly
                    value={repeatedUnits === '' ? defaultMsg : repeatedUnits}
                    style={{ width: '3rem', textAlign: 'center', borderRadius:'0', borderRight: 'none', borderLeft: 'none'}}
                />
                <button className="ui button" style={{borderRadius: '.28571429rem'}} onClick={handleIncrement}>+</button>
                <button className="ui button" style={{ marginLeft: '0.5vh', borderRadius: '.28571429rem' }} onClick={handleDefault}>{defaultMsg}</button>
            </div>
        </div>
    );
}
